import { render, staticRenderFns } from "./MatterOrderJudgment.vue?vue&type=template&id=1e13ad52"
import script from "./MatterOrderJudgment.vue?vue&type=script&lang=js"
export * from "./MatterOrderJudgment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports